// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.item_row {
  display: inline-flex;
  justify-content: space-between;
  border-bottom: 1px solid #f5f5f5;
  padding: 7px 0px;
  box-sizing: border-box;
  width: 100%;
  /* height: 160px; */
  background: #f6e8d7;
}
.item_row .inline_row {
  display: flex;
  justify-content: flex-start;
}
.item_row .image_wrap {
  margin-left: 10px;
  margin-right: 10px;
}
.item_row .image_wrap img {
  width: 120px;
  height: 100px;
  min-width: 27px;
  object-fit: contain;
  margin-top: 4px;
  border-radius: 3px;
}
.item_row .info_side {
  padding: 20px 0px;
  padding-bottom: 10px;
  box-sizing: border-box;
}
.item_row h1 {
  font-size: 14px;
  margin: 0;
  color: #313131;
}
.item_row p {
  font-size: 12px;
  margin: 0;
  margin-top: 5px;
  color: #8e8e8e;
}
.item_row ion-icon {
  width: 54px;
  font-size: 24px;
  color: #d1b0a0;
  margin-top: 40px;
  margin-right: 11px;
}

.tags {
  display: inline-flex;
  overflow: scroll;
  margin-top: 10px;
  width: 220px !important;
  padding-bottom: 13px;
}
.tags ion-chip {
  white-space: nowrap;
  min-width: -moz-fit-content;
  min-width: fit-content;
  height: 23px;
  font-size: 10px;
  margin: 0;
  margin-right: 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/messenger/msg-header/msg-context-row/msg-context-row.component.scss"],"names":[],"mappings":"AAAA;EACI,oBAAA;EACA,8BAAA;EACA,gCAAA;EACA,gBAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;AACJ;AACI;EACI,aAAA;EACA,2BAAA;AACR;AAEI;EACI,iBAAA;EACA,kBAAA;AAAR;AAEQ;EACI,YAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AAAZ;AAII;EACI,iBAAA;EACA,oBAAA;EACA,sBAAA;AAFR;AAKI;EACI,eAAA;EACA,SAAA;EACA,cAAA;AAHR;AAMI;EACI,eAAA;EACA,SAAA;EACA,eAAA;EACA,cAAA;AAJR;AAOI;EACI,WAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AALR;;AASA;EACI,oBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;AANJ;AAQI;EACI,mBAAA;EACA,2BAAA;EAAA,sBAAA;EACA,YAAA;EACA,eAAA;EAEA,SAAA;EACA,iBAAA;AAPR","sourcesContent":[".item_row {\n    display: inline-flex;\n    justify-content: space-between;\n    border-bottom: 1px solid #f5f5f5;\n    padding: 7px 0px;\n    box-sizing: border-box;\n    width: 100%;\n    /* height: 160px; */\n    background: #f6e8d7;\n\n    .inline_row {\n        display: flex;\n        justify-content: flex-start;\n    }\n\n    .image_wrap {\n        margin-left: 10px;\n        margin-right: 10px;\n\n        img {\n            width: 120px;\n            height: 100px;\n            min-width: 27px;\n            object-fit: contain;\n            margin-top: 4px;\n            border-radius: 3px;\n        }\n    }\n\n    .info_side {\n        padding: 20px 0px;\n        padding-bottom: 10px;\n        box-sizing: border-box;\n    }\n\n    h1 {\n        font-size: 14px;\n        margin: 0;\n        color: #313131;\n    }\n\n    p {\n        font-size: 12px;\n        margin: 0;\n        margin-top: 5px;\n        color: #8e8e8e;\n    }\n\n    ion-icon {\n        width: 54px;\n        font-size: 24px;\n        color: #d1b0a0;\n        margin-top: 40px;\n        margin-right: 11px;\n    }\n}\n\n.tags {\n    display: inline-flex;\n    overflow: scroll;\n    margin-top: 10px;\n    width: 220px !important;\n    padding-bottom: 13px;\n\n    ion-chip {\n        white-space: nowrap;\n        min-width: fit-content;\n        height: 23px;\n        font-size: 10px;\n\n        margin: 0;\n        margin-right: 5px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
